import { useState } from 'react';

import { Button } from '@/components/ui/Button';
// The gallery's whole job is to show every shared piece, and the status-page
// shape lives in the errors feature; this is an exhibit, not a dependency.
// eslint-disable-next-line no-restricted-imports
import { StatusPage } from '@/features/errors/StatusPage';

import { State } from '../State';

/**
 * Shown on demand, not inline: StatusPage renders a page's h1, renames the
 * tab, and moves focus to its heading the moment it mounts - which is right
 * when it is a page and wrong as a permanent fixture halfway down this one.
 */
export function StatusPageExamples() {
  const [shown, setShown] = useState(false);

  return (
    <State
      title="No access, not found and failed share this shape"
      note="It takes focus when it appears, as it does on arrival at a real refusal."
    >
      <Button
        variant="secondary"
        size="sm"
        onClick={() => setShown((s) => !s)}
        data-testid="gallery-status-page-toggle-button"
      >
        {shown ? 'Hide the status page' : 'Show the status page'}
      </Button>

      {shown ? (
        <StatusPage
          title="You do not have access to this page"
          address="/staff/organizations"
          documentTitle="No access"
          testId="gallery-status"
          action={
            <Button
              variant="secondary"
              onClick={() => setShown(false)}
              data-testid="gallery-status-page-back-button"
            >
              Back to the gallery
            </Button>
          }
        >
          is only available to Activist Technologies staff.
        </StatusPage>
      ) : null}
    </State>
  );
}
